document.addEventListener('DOMContentLoaded', function() {
  // Use Event Delegation for better performance (one listener for all cards)
  document.addEventListener('click', function(e) {
    
    // 1. Check if the user clicked a "Moon Variant Button"
    if (!e.target.matches('.moon-variant-button')) return;

    e.preventDefault();
    e.stopPropagation();

    const button = e.target;
    const card = button.closest('.moon-product-card'); // Ensure this matches your HTML class
    if (!card) return;

    // 2. Visual Update: Toggle the selected class
    const variantButtons = card.querySelectorAll('.moon-variant-button');
    variantButtons.forEach(btn => btn.classList.remove('moon-variant-button--selected'));
    button.classList.add('moon-variant-button--selected');

    // 3. Update Data
    const variantId = button.dataset.variantId;
    const variantIdInput = card.querySelector('.product-variant-id'); // Your hidden input
    const submitButton = card.querySelector('.quick-add__submit');
    const buttonTextSpan = submitButton ? submitButton.querySelector('span') : null;
    const productHandle = card.dataset.productHandle; // Make sure you added this to Liquid!

    // Update hidden input immediately
    if (variantIdInput) variantIdInput.value = variantId;

    // 4. AJAX Check for Availability
    if (submitButton) {
      // Set Loading State
      submitButton.disabled = true;
      if (buttonTextSpan) buttonTextSpan.textContent = '...';

      // Fetch Product Data
      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(productData => {
          // Find the variant we just clicked
          const variant = productData.variants.find(v => v.id.toString() === variantId.toString());

          if (variant) {
            if (variant.available) {
              // VARIANT IS IN STOCK
              submitButton.disabled = false;
              if (buttonTextSpan) buttonTextSpan.textContent = submitButton.dataset.addToCartText || 'Add to cart';
            } else {
              // VARIANT IS SOLD OUT
              submitButton.disabled = true;
              if (buttonTextSpan) buttonTextSpan.textContent = submitButton.dataset.soldOutText || 'Sold out';
            }
          } else {
             // Should not happen, but fallback
             submitButton.disabled = true;
             if (buttonTextSpan) buttonTextSpan.textContent = 'Unavailable';
          }
        })
        .catch(err => {
          console.error('Error fetching stock status:', err);
          // Safety: Enable button if check fails so user can at least try
          submitButton.disabled = false;
          if (buttonTextSpan) buttonTextSpan.textContent = submitButton.dataset.addToCartText || 'Add to cart';
        });
    }
  });
});